"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const joi_1 = __importDefault(require("joi"));
const constants_1 = require("../constants");
const toLower_1 = __importDefault(require("lodash/toLower"));
const defaults_1 = require("../defaults");
const common_1 = __importDefault(require("./common"));
const validator = (schema) => (payload) => schema.validate(payload, { abortEarly: false, convert: true });
// validate the (individual) user input for signup
const UserSignupSchema = joi_1.default.object({
    email: common_1.default.email.required(),
    password: common_1.default.password.required(),
    username: common_1.default.username.required(),
    displayName: common_1.default.name.required(),
    emailSubscription: joi_1.default.boolean().default(false),
    /** avatarUrl would be empty by default, so only use this if using a fallback for avatarUrl being undefined */
    avatarUrl: common_1.default.url,
    userPrivacy: common_1.default.postPrivacy.default((0, toLower_1.default)(constants_1.PostPrivacy.PUBLIC)),
    phoneNumber: common_1.default.phoneNumber,
    location: common_1.default.location.default(defaults_1.defaultLocationData),
    unitPreference: common_1.default.unitPreference.default((0, defaults_1.getDefaultUnitPreference)()),
    bio: common_1.default.bio,
    socialMediaAccounts: common_1.default.socialMediaAccounts(),
});
// validate the (trainer) user input for signup
const TrainerSignupSchema = UserSignupSchema.keys({
    businessName: common_1.default.name,
});
// validate the user input for Google login
const GoogleLoginSchema = joi_1.default.object({
    email: common_1.default.email.required(),
    googleIdToken: joi_1.default.string().required(),
});
// validate the user input for login
const LoginSchema = joi_1.default.object({
    email: common_1.default.email.required(),
    password: joi_1.default.string().required(),
});
// validate confirm (individual) user details for post Google signup
const ConfirmUserDetailsSchema = joi_1.default.object({
    username: common_1.default.username.required(),
    displayName: common_1.default.name,
});
// validate confirm (trainer) user details for post Google signup
const ConfirmTrainerDetailsSchema = ConfirmUserDetailsSchema.keys({
    businessName: common_1.default.name,
});
const ForgotPasswordSchema = joi_1.default.object({
    email: common_1.default.email.required(),
});
const ResetPasswordSchema = joi_1.default.object({
    token: common_1.default.token.required(),
    newPassword: common_1.default.password.required(),
});
module.exports = {
    UserSignupSchema: validator(UserSignupSchema),
    TrainerSignupSchema: validator(TrainerSignupSchema),
    GoogleLoginSchema: validator(GoogleLoginSchema),
    LoginSchema: validator(LoginSchema),
    ConfirmUserDetailsSchema: validator(ConfirmUserDetailsSchema),
    ConfirmTrainerDetailsSchema: validator(ConfirmTrainerDetailsSchema),
    ForgotPasswordSchema: validator(ForgotPasswordSchema),
    ResetPasswordSchema: validator(ResetPasswordSchema),
};
//# sourceMappingURL=auth.js.map